<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col md:w-1/2 lg:w-4/5 xl:w-4/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-2/5 d-theme-dark-bg p-6">
              <img style="margin: 0 auto" height="50px" src="https://firebasestorage.googleapis.com/v0/b/pedido-rapido-app.appspot.com/o/sticky-logo.png?alt=media&token=a5ff609d-6f49-40b2-95fa-80dbb30e4d21" /> 

              <a-steps class="m-6 mt-8 margin-auto no-selection" direction="vertical" v-model="stepAdapter">
                <a-step v-for="(stp, i) in steps" :key="stp.title"
                  :title="stp.title" :description="stp.description"
                  :disabled="i > lastValidStep"/>
              </a-steps>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-3/5 ">

              <Stepper v-model="step" :steps="7">
                <template slot="1">
                  <Terms/>
                </template>
                <template slot="2">
                  dois
                </template>
                <template slot="3">
                  tres
                </template>
              </Stepper>
              <vs-button v-show="step <= steps.length || invalid" @click="next"> 
                Próximo
                <a-icon type="right"/>
              </vs-button>
            </div>

          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Stepper from "../../../components/Stepper.vue";
import Terms from './steps/Terms.vue';

    export default {
      components: { Stepper, Terms },
      data() {
        return {
          steps: [
            { title: 'Termos', description: 'A única parte "burocrática"' },
            { title: 'Meus dados', description: 'Criação da conta Administradora' },
            { title: 'Dados do Negócio', description: 'Aqui, sabemos sobre a sua empresa' },
            { title: 'Identificador Pedido Rápido', description: 'O id único da sua empresa' },
            { title: 'Mesas', description: 'Gere os QRCodes para impressão' },
            // { title: 'Primeiro Produto', description: 'Cadastre o primeiro produto' },
            { title: 'Aprenda', description: 'Tópicos úteis para usar o sistema' },
            { title: 'Pronto!', description: '' },
          ],
          step: 1,
          lastValidStep: 0
        }
      },
      computed: {
        stepAdapter: {
          get () {
            return this.step - 1;
          },
          set (v) {
            this.step = v + 1;
          }
        },
        invalid () {
          return false;
        }
      },
      methods: {
        next () {
          if (this.lastValidStep < this.step)
            this.lastValidStep++;
          this.step++;
        }
      }
    }
</script>

<style lang="scss" scoped>
  .no-selection {
   user-select: none;
}
</style>